import { VariantProps } from 'tailwind-variants';

import { UiModStickyScroll } from '@/fo/ui/mod/sticky/scroll';

import { styles } from './UiProductLayoutPage.styles';

type Variants = VariantProps<typeof styles>;
type NativeElement = React.HTMLAttributes<HTMLDivElement>;

type SlotNameProps =
  | 'top'
  | 'main'
  | 'picture'
  | 'recommends'
  | 'delivery'
  | 'advantages'
  | 'banners';

export interface UiProductLayoutPageProps {
  className?: string;
  color?: Variants['color'];
  slots: Record<SlotNameProps, React.ReactNode>;
  onClick?: NativeElement['onClick'];
}

export function UiProductLayoutPage({
  className,
  color,
  slots: slotsMap
}: UiProductLayoutPageProps) {
  const slots = styles({ color });
  return (
    <div className={slots.base({ className })}>
      <UiModStickyScroll
        className={slots.firstPart({
          className: [
            '[--offset-top:calc(var(--head-fixed-height)+20px)]',
            '[--offset-bottom:20px]',
            'max-lg:[--inactive:1]'
          ]
        })}
      >
        <div className={slots.top({ className: 'lg:hidden' })}>
          {slotsMap.top}
        </div>
        {slotsMap.picture}
        <div className={slots.advantages({ className: 'max-lg:hidden' })}>
          {slotsMap.advantages}
        </div>
        <div className={slots.banners({ className: 'max-lg:hidden' })}>
          {slotsMap.banners}
        </div>
      </UiModStickyScroll>
      <div className={slots.secondPart()}>
        <div>
          <div className={slots.top({ className: 'max-lg:hidden' })}>
            {slotsMap.top}
          </div>
          {slotsMap.main}
        </div>
        {slotsMap.recommends}
        <div className={slots.advantages({ className: 'lg:hidden' })}>
          {slotsMap.advantages}
        </div>
        {slotsMap.delivery}
        <div className={slots.banners({ className: 'lg:hidden' })}>
          {slotsMap.banners}
        </div>
      </div>
    </div>
  );
}
